import React from 'react';
import {Button} from 'components';
import {Announcement} from './announcement';
import css from './announcement.module.scss';

export class Update_2024_10_09 extends Announcement {
  render() {
    return (
      <>
        <h1>Goal Templates</h1>
        <p>Introducing 64 New Goal Templates, with detailed Action Plan and a complete set of Milestone and Activities.</p>
        <p className={css.footer}>
          <Button onClick={this.props.decline}>
            {this.props.isLast ? 'close' : 'next'}
          </Button>
        </p>
      </>
    );
  }
}
